import parse from "html-react-parser";
import DOMPurify from "dompurify";


type SafeHtmlRendererProps = {
    htmlContent: string;
    className?: string;
}
export const SafeHtmlRenderer = ({ htmlContent, className }:SafeHtmlRendererProps) => {
    const cleanHTML = DOMPurify.sanitize(htmlContent);
    return <div className={`safe-html-wrapper ${className ?? ""}`}>{parse(cleanHTML)}</div>;
};